import * as React from 'react';

type Props = {
  disabled?: boolean;
  children: React.ReactElement;
};

const LinkWrapper = ({ disabled, children }: Props) => {
  return <span className={disabled ? 'cursor-not-allowed' : ''}>{children}</span>;
};

export default LinkWrapper;
